import yup from '../../../translations/yup/yupLocale';

const validationSchema = yup.object({
  username: yup.string().min(3).required().label('Login'),
  password: yup.string().min(3).required().label('Password'),
});

export default validationSchema;
